import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const ValidateSession = ({ isToken, children }) => {
    const { isAuthenticated } = useSelector(state => state.auth);

    if (isToken && isAuthenticated){
        return <Navigate to='/dashboard' replace />;
    }

    if(children){
        return children;
    }else{
        return <Outlet />;
    }
}

export default ValidateSession;